import { type ApiClient, listQueryParams } from "./client";
import type { AdminRole, ListQuery, Page, StaffCredentials, StaffDetail, StaffFilters, StaffRow } from "./types";

/** Platform staff (this console's own accounts). Implementations: HTTP (below) and mock (src/api/mock). */
export interface StaffApi {
  list(query: ListQuery<StaffFilters>): Promise<Page<StaffRow>>;
  get(id: string): Promise<StaffDetail>;
  create(input: { name: string; email: string; role: AdminRole; slackUserId?: string | null }): Promise<StaffCredentials>;
  update(id: string, patch: { name?: string; role?: AdminRole; slackUserId?: string | null }): Promise<StaffDetail>;
  disable(id: string, reason: string): Promise<StaffDetail>;
  enable(id: string): Promise<StaffDetail>;
  resetPassword(id: string): Promise<StaffCredentials>;
  revokeSessions(id: string): Promise<StaffDetail>;
}

export function createHttpStaffApi(client: ApiClient): StaffApi {
  return {
    list: (q) => client.call("listStaff", { query: listQueryParams(q) }),
    get: (id) => client.call("getStaff", { params: { id } }),
    create: (input) => client.call("createStaff", { body: input }),
    update: (id, patch) => client.call("updateStaff", { params: { id }, body: patch }),
    disable: (id, reason) => client.call("disableStaff", { params: { id }, body: { reason } }),
    enable: (id) => client.call("enableStaff", { params: { id } }),
    resetPassword: (id) => client.call("resetStaffPassword", { params: { id } }),
    revokeSessions: (id) => client.call("revokeStaffSessions", { params: { id } }),
  };
}
